module.exports = __webpack_public_path__ + "static/media/GoogleDA-3.6b215f83.jpg";